/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsKey: {
  name: 'key';
  data: string;
} = {
  name: 'key',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.414 2A2 2 0 0 0 17 2.586l-7.583 7.583a6 6 0 1 0 4.175 3.653L17 10.414l1.293 1.293a1 1 0 0 0 1.414-1.414L18.414 9 19.5 7.914l.793.793a1 1 0 1 0 1.414-1.414l-.793-.793.5-.5A2 2 0 0 0 22 4.586V4a2 2 0 0 0-2-2h-1.586Zm-5.889 10.06a6.031 6.031 0 0 0-1.15-1.021L18.415 4H20v.586l-1.207 1.207L17 7.586 15.586 9l-3.06 3.06ZM4 16a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm3 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
